(function () {
  let triggers = qsa('.js-mini-cart__trigger');
  const miniCart = qs('.js-mini-cart');
  const main = qs('#js-main');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      if (main && main.dataset && main.dataset.page == 'cart') {
        return;
      }

      showMiniCart();
    });
  });

  addGlobalEventListener('click', '.js-mini-cart__close', () => {
    hideMiniCart();
  });

  addGlobalEventListener('click', '.js-mini-cart__remove', (e) => {
    removeItem(e.dataset.key);
  });

  addGlobalEventListener('click', '.js-mini-cart__quantity-subtract', (e) => {
    let item = getClosest('.js-mini-cart__item', e);
    let quantity = qs('.js-mini-cart__quantity-value', item);

    if (+quantity.innerText > 1) {
      window.Shopify.theme.cart
        .updateItem(item.dataset.key, { quantity: +quantity.innerText - 1 })
        .then(refreshMiniCart);
    } else {
      removeItem(item.dataset.key);
    }
  });

  addGlobalEventListener('click', '.js-mini-cart__quantity-add', (e) => {
    let item = getClosest('.js-mini-cart__item', e);
    let quantity = qs('.js-mini-cart__quantity-value', item);

    console.log(item.dataset.key);

    window.Shopify.theme.cart
      .updateItem(item.dataset.key, { quantity: +quantity.innerText + 1 })
      .then(refreshMiniCart);
  });

  function removeItem(key) {
    window.Shopify.theme.cart.removeItem(key).then(refreshMiniCart);
  }

  function showMiniCart() {
    scrollLock();
    miniCart.classList.add('mini-cart--active');
    refreshMiniCart();
  }

  function hideMiniCart() {
    scrollLock(false);
    miniCart.classList.add('mini-cart--active');
    miniCart.classList.remove('mini-cart--active');
  }

  function refreshMiniCart() {
    fetch(window.Shopify.routes.root + '?sections=mini-cart')
      .then((res) => res.json())
      .then((res) => {
        let template = document.createElement('div');
        template.innerHTML = res['mini-cart'];
        let oldContainer = qs('.js-mini-cart__container', miniCart);
        let newContainer = qs('.js-mini-cart__container', template);

        oldContainer.innerHTML = newContainer.innerHTML;
        let cartSummary = qs('.js-mini-cart__summary');      
        let headerCart = qs('#js-header-cart-count');

        if (headerCart && cartSummary && cartSummary.dataset && cartSummary.dataset.cartSize) {
          headerCart.innerHTML = cartSummary.dataset.cartSize;
        }
      });
  }

  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.miniCart = {
    show: showMiniCart,
    hide: hideMiniCart,
    refresh: refreshMiniCart,
  };
})();
